import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'gatsby-link';
import {categoryHref} from 'lib/categories';
import Icon from './Icon';
import styles from './topics.module.scss';

function count(num) {
  const label = num > 1 ? 'articles' : 'article';

  return `${num} ${label}`;
}

const Topic = ({category}) => (
  <div className="column is-one-third">
    <Link to={category.href || categoryHref(category)}>
      <div className={classNames('card', styles.Topic)}>
        <Icon category={category} />
        <div className={classNames('card-content', styles.Topic__content)}>
          <p className={classNames('is-size-4', styles.Topic__name)}>
            {category.name}
          </p>
          <p className={styles.Topic__description}>{category.description}</p>
          <span className="has-text-link">{count(category.articleCount)}</span>
        </div>
      </div>
    </Link>
  </div>
);

Topic.propTypes = {
  category: PropTypes.shape({
    articleCount: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    href: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default Topic;



// WEBPACK FOOTER //
// ./src/components/topics/Topic.js